import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import VirusBeaconClient from '../../clients/VirusBeaconClient';
import stateImgDiseases from '../../state/stateImgDiseases';
import stateImgMeasures from '../../state/stateImgMeasures';
import stateImgAnatomic from '../../state/stateImgAnatomics';

function useBeaconImagenFilters() {
  const [diseases, setDiseases] = useRecoilState(stateImgDiseases);
  const [measures, setMeasures] = useRecoilState(stateImgMeasures);
  const [anatomic, setAnatomic] = useRecoilState(stateImgAnatomic);

  const [search, setSearch] = useState(0 as number);

  useEffect(() => {
    if (0 === measures.length && search === 0) {
      const abortController = new AbortController();
      setSearch(1);
      (async () => {
        try {
          const filteringTerms = await VirusBeaconClient.getFilteringTermsImg(
            abortController.signal
          );

          if (0 === diseases.length) {
            const diseases = filteringTerms.filter(
              (elem) => elem.scope === 'conditions' && elem.type === 'ontology'
            );
            setDiseases(diseases);
          }

          if (0 === measures.length) {
            const measures = filteringTerms.filter(
              (elem) => elem.scope === 'measurements'
            );
            setMeasures(measures);
          }

          if (0 === anatomic.length) {
            const anatomic = filteringTerms.filter(
              (elem) => elem.scope === 'occurrences' && elem.type === 'ontology'
            );
            setAnatomic(anatomic);
          }
        } catch (error) {
          if (!abortController.signal.aborted) {
            // error!
            console.log('ERROR: ' + error);
          }
        }
      })();

      return () => {
        abortController.abort();
      };
    } else {
      return () => {};
    }
  }, [measures]);
}

export default useBeaconImagenFilters;
